export const page_text_es = {
  // Formación (M10)
  nav_formacion: "Formación",
  formacion_title: "Formación",
  formacion_person_label: "Persona:",
  formacion_change: "Cambiar",
  formacion_who: "¿Quién eres?",
  formacion_who_hint: "Tu progreso y tus evaluaciones se guardan a tu nombre. Elige tu nombre de la lista del equipo.",
  formacion_no_staff: "Tu farmacia aún no tiene equipo registrado. Pídele a Farmaval que lo dé de alta.",
  formacion_empty: "No hay contenido disponible en esta carpeta todavía.",
  formacion_home: "Inicio",
  formacion_folder: "Carpeta",
  formacion_block: "Bloque",
  formacion_locked: "Bloqueado",
  formacion_seen: "Visto",
  formacion_close: "Cerrar",
  formacion_open_tab: "Abrir en pestaña",
  formacion_kind_video: "Vídeo",
  formacion_kind_link: "Enlace",
  formacion_kind_template: "Documento",
  formacion_kind_image: "Imagen",
  formacion_quiz_btn: "Hacer cuestionario",
  formacion_quiz_send: "Enviar respuestas",
  formacion_quiz_result: "Tu nota",
  formacion_quiz_best: "Mejor nota",
  formacion_quiz_back: "Volver",
  formacion_quiz_unanswered: "Responde todas las preguntas antes de enviar.",
  taller_inhaladores_name: "Taller de Inhaladores",
  taller_inhaladores_desc: "Formación práctica en dispositivos de inhalación",
  taller_insulinas_name: "Taller de Insulinas",
  taller_insulinas_desc: "Formación práctica en insulinas y plumas",
  formacion_mentoring_btn: "Agendar mentoría tras la formación",
  formacion_mentoring_confirm: "¿Avisar a vuestro mentor de que queréis agendar la mentoría de este bloque?",
  formacion_mentoring_sent: "¡Hecho! Tu mentor ha sido avisado y coordinará la sesión con vosotros.",
  formacion_mentoring_already: "Ya había una solicitud pendiente para este bloque: vuestro mentor ya está avisado.",
  formacion_result_title: "Mi resultado ProBioMentor",
  formacion_result_pending: "pendiente",
  formacion_result_noquiz: "sin examen",
  formacion_result_diploma: "Descargar diploma de experto",
  formacion_result_certificate: "Descargar certificado de aprovechamiento",
  formacion_result_retake_hint: "Puedes repetir el examen del bloque suspendido para subir tu media y conseguir el diploma (repesca).",
  formacion_result_incomplete: "Completa la evaluación de todos los bloques para obtener tu diploma o certificado.",

  // Servicios
  sati_name: "SATI",
  sati_desc: "Servicio de acompañamiento en terapia inhalada",
  satib_name: "SATIB",
  satib_desc: "Servicio básico de acompañamiento en terapia inhalada",
  iretia_name: "IRETIA",
  iretia_desc: "Intervención rápida en terapia inhalada aguda",
  cepoc_name: "CEPOC",
  cepoc_desc: "Cribado de Enfermedad Pulmonar Obstructiva Crónica EPOC",
  probio_name: "ProbioMentor",
  probio_desc: "Recomendación de probióticos basada en evidencia",

  sati_test_name: "SATI Test",
  sati_test_desc: "Servicio en desarrollo",

  rcm_name: "RCM",
  rcm_desc: "Control de riesgo cardio metabólico",
  adir_name: "ADIR",
  adir_desc: "Ajuste de dosis en insuficiencia renal",

  // Navigation
  nav_home: "Inicio",
  nav_patients: "Pacientes",
  nav_services: "Servicios",
  nav_profile: "Perfil",
  nav_calendar: "Agenda",
  nav_reports: "Consultas",
  nav_language: "Idioma",
  nav_language_ca: "Català",
  nav_language_es: "Español",
  nav_logout: "Cerrar sesión",
  nav_owner: "Modo titular",

  nav_marketing: "Material divulgativo",
  nav_cart: "Reposición",

  // Carrito de reposición (FA-01 a FA-04)
  cart_tab_current: "Mi carrito",
  cart_tab_orders: "Mis pedidos",
  cart_empty: "Tu carrito está vacío. Los productos de Farmaval que vendas durante los servicios se añadirán aquí automáticamente, y también puedes añadir los que quieras desde el catálogo.",
  cart_add_label: "Añadir producto del catálogo",
  cart_add_price: "Precio",
  cart_btn_add: "Añadir",
  cart_lbl_product: "Producto",
  cart_lbl_ref: "Referencia",
  cart_lbl_units: "Unidades",
  cart_lbl_price: "Precio",
  cart_lbl_iva: "IVA",
  cart_lbl_total: "Total",
  cart_lbl_order: "Pedido",
  cart_lbl_date: "Fecha",
  cart_lbl_shipping: "Envío",
  cart_summary_title: "Resumen del pedido",
  cart_subtotal: "Base imponible",
  cart_shipping: "Gastos de envío",
  cart_total: "Total",
  cart_free: "Gratis",
  cart_btn_submit: "Tramitar pedido",
  cart_btn_remove: "Quitar",
  cart_confirm_remove: "¿Quieres quitar este producto del carrito?",
  cart_confirm_submit: "¿Tramitar el pedido de reposición?",
  cart_submitting: "Tramitando...",
  cart_free_shipping_hint: "Te faltan {amount} € (sin IVA) para el envío gratuito.",
  cart_free_shipping_ok: "Tu pedido tiene envío gratuito.",
  cart_order_placed: "Pedido {number} tramitado correctamente.",
  cart_orders_empty: "Todavía no has tramitado ningún pedido de reposición.",
  cart_order_by_farmaval: "Tramitado por Farmaval",
  cart_error_generic: "No se ha podido completar la operación. Vuelve a intentarlo.",
  marketing_root_label: "Inicio",
  marketing_empty: "Todavía no hay material divulgativo disponible.",

  // Login
  login_title: "Inicio de sesión",
  login_user_placeholder: "Usuario o email",
  login_password_placeholder: "Contraseña",
  login_button: "Autentificar",
  login_error_user: "Usuario o contraseña no válidos.",
  login_error_blocked:
    "El acceso de esta farmacia está desactivado. Ponte en contacto con Farmaval.",
  login_error_server: "Error de conexión.",

  // Acceso del mentor a sus farmacias
  mentor_pharmacies_title: "Elige una farmacia",
  mentor_pharmacies_greeting: "Hola, {name}. Entrarás a la app como la farmacia que elijas.",
  mentor_pharmacies_empty: "No tienes farmacias asignadas y confirmadas.",
  mentor_pharmacy_current: "Farmacia actual",
  mentor_mirror_title: "Practicar formación",
  mentor_mirror_info: "Farmacia espejo, sin datos de ninguna farmacia",
  mentor_pharmacies_back: "Volver",
  mentor_error_access: "No tienes acceso a esta farmacia.",
  mentor_error_pending_services:
    "Hay servicios pendientes de sincronizar. Sincronízalos antes de cambiar de farmacia.",
  mentor_note_cart: "El pedido lo envía la farmacia.",
  mentor_note_agreement: "El contrato lo firma la farmacia.",
  mentor_banner_text: "Modo mentor: estás viendo {pharm} como {name}.",
  nav_mentor_switch: "Cambiar farmacia",

  login_password_forgotten:
    "Si ha olvidado la contraseña, introduzca el email y pulse [Recuperar contraseña] para recibir un correo con un código de recuperación.",
  login_send_password: "Recuperar contraseña",
  login_error_recover: "Error al inciar proceso de recuperación.",
  login_error_email: "Correo de recuperación no válido.",
  login_recover_ok: "Código enviado al correo.",

  update_password_title: "Actualizar contraseña",
  update_password_info:
    "Por motivos de seguridad, tiene que crear una contraseña nueva para acceder al aplicativo.",
  update_password_placeholder: "Contraseña nueva",
  update_repassword_placeholder: "Confirmar la contraseña nueva",
  update_password_button: "Actualizar contraseña",
  update_password_cancel: "Cancelar",
  update_password_must_1: "Debe contener al menos un número.",
  update_password_must_2: "Debe contener al menos una letra mayúsucla.",
  update_password_must_3: "Debe contener al menos un símbolo.",
  update_password_must_4: "Debes confirmar contraseña.",
  update_error:
    "Problema al actualizar contraseña. Por favor, vuelva a intentarlo antes de contactar con Farmaval.",
  update_same: "La nueva contraseña debe ser diferente a la anterior.",
  update_ok_title: "Contraseña actualizada",
  update_ok: "Tu nueva contraseña ya está activa. Úsala la próxima vez que entres en Farmaval.",

  register_title: "¡Bienvenido!",
  register_info:
    "Para registrar su farmacia, por favor, introduzca un email, una contraseña de acceso y el código de registro suministrado por su delegado.<br><br>La contraseña debe:",
  register_email: "Email",
  register_password: "Contraseña de acceso",
  register_repassword: "Confirmar contraseña",
  register_password_must_1: "Contener al menos un número.",
  register_password_must_2: "Contener al menos una letra mayúsucla.",
  register_password_must_3: "Contener al menos un símbolo.",
  register_password_must_4: "Debes confirmar contraseña.",
  register_pharm: "Nombre de la farmacia",
  register_code: "Código de Prodeco",
  register_pharm_button: "Registrar farmacia",
  register_error_func:
    "Se ha producido un problema inesperado. Por favor, póngase en contacto con Farmaval.",
  register_error_email: "El email ya está registrado.",
  register_error_code: "El código no es válido.",

  register_notify_title: "Registro correcto",
  register_notify_info:
    "Le hemos enviado un email con los datos de registro (compruebe la bandeja de spam si no lo ha recibido). Por favor, inicie sesión para continuar con el proceso de alta.",
  register_continue_button: "Iniciar sesión",

  alert_code_title: "Modo Titular",
  alert_code_info:
    "Para acceder al modo titular debe introducir la contraseña:",
  alert_code_wrong: "Contraseña de titular incorrecta.",
  alert_code_recover: "He olvidado la contraseña",
  alert_code_recover_info:
    "Se enviará un email a la dirección de correo del titular.",
  alert_code_recover_email:
    "Se ha enviado un email con la nueva contraseña a la dirección: ",
  alert_code_recover_error:
    "Se ha producido un error al enviar el correo con la nueva contraseña.",

  // Formación
  formation_sati: "Servicio SATI",
  formation_iretia: "Servicio IRETIA",
  formation_cepoc: "Servicio CEPOC",
  formation_all: "Sesiones de valor",

  videos_label: "Videos",
  all_videos_label: "Para el responsable",
  team_videos_label: "Para el equipo",
  material_label: "Material adicional",
  video_iretia_1: "1. Taller inhaladores Presurizados.",
  video_iretia_2: "2. Taller inhaladores Camara de inhalación.",
  video_iretia_3: "3. Taller inhaladores polvo seco monodosis.",
  video_iretia_4: "4. Taller inhaladores polvo seco multidosis con depósito.",
  video_iretia_5: "5. Taller de inhaladores polvo seco con blíster.",
  video_iretia_6:
    "6. Conceptos de aerosolterapia y distribución de partículas.",
  video_iretia_7: "7. La técnica inhalada.",
  link_iretia_1: "https://player.vimeo.com/video/838398122",
  link_iretia_2: "https://player.vimeo.com/video/688355173",
  link_iretia_3: "https://player.vimeo.com/video/684574347",
  link_iretia_4: "https://player.vimeo.com/video/688361792",
  link_iretia_5: "https://player.vimeo.com/video/688367203",
  link_iretia_6: "https://player.vimeo.com/video/688371703",
  link_iretia_7: "https://player.vimeo.com/video/688623093",
  material_iretia_1: "1- Consenso asma pediatría 2021 REGAP.",
  material_iretia_2: "2- Dossier formativo.",
  material_iretia_3: "3- Informe dispositivos de polvo seco unidosis.",
  material_iretia_4: "4- Informe dispositivos de polvo seco multidosis.",
  material_iretia_5: "5-Informe dispositivos presurizados sin cámara.",
  material_iretia_6: "6- Informe dispositivos presurizados con cámara.",
  material_iretia_7:
    "7- Informe dispositivos presurizados con cámara en niños y lactantes.",
  file_iretia_1:
    "https://www.farmaval.net/docs/8-%20Consenso%20asma%20pediatria%202021%20REGAP.pdf",
  file_iretia_2: "https://www.farmaval.net/docs/9-Dossier%20formativo.pdf",
  file_iretia_3:
    "https://www.farmaval.net/docs/iretia/es/polvo_seco_unidosis.pdf",
  file_iretia_4:
    "https://www.farmaval.net/docs/iretia/es/polvo_seco_multidosis.pdf",
  file_iretia_5:
    "https://www.farmaval.net/docs/iretia/es/presurizados_sin_c%C3%A1mara.pdf",
  file_iretia_6:
    "https://www.farmaval.net/docs/iretia/es/presurizados_con_c%C3%A1mara.pdf",
  file_iretia_7:
    "https://www.farmaval.net/docs/iretia/es/presurizados_c%C3%A1mara_lactantes.pdf",

  video_sati_1: "1. Una historia y un sueño.",
  video_sati_2: "2. ¿Por qué es necesario el servicio SATI?",
  video_sati_3: "3. Nuestro rol como profesionales sanitarios.",
  video_sati_4: "4. Taller inhaladores Presurizados.",
  video_sati_5: "5. Taller inhaladores Camara de inhalación.",
  video_sati_6: "6. Taller inhaladores polvo seco monodosis.",
  video_sati_7: "7. Taller inhaladores polvo seco multidosis con depósito.",
  video_sati_8: "8. Taller de inhaladores polvo seco con blíster.",
  video_sati_9: "9. Taller de inhaladores: Material de soporte.",
  video_sati_10: "10. Conclusiones y plan de acción para todo el equipo.",
  video_sati_11:
    "11. Conceptos de aerosolterapia y distribución de partículas.",
  video_sati_12: "12. La técnica inhalada.",
  video_sati_13: "13. El aparato respiratorio.",
  video_sati_14:
    "14. Patologia respiratoria y Principales diferencias entre Asma y EPOC.",
  video_sati_15: "15. El servicio SATI definición.",
  video_sati_16: "16. Funcionamiento de Farmaval App.",
  video_sati_17: "17. Recogida de datos generales del paciente.",
  video_sati_18: "18. SATI LOPD.",
  video_sati_19: "19. Diagnostico y farmacoterapia.",
  video_sati_20: "20. Cuestionarios de control de la patología respiratoria.",
  video_sati_21: "21. Educación sanitaria sobre la patología respiratoria.",
  video_sati_22: "22. Valoración de la técnica inhalada.",
  video_sati_23: "23. Formación y mejora de la técnica inhalada.",
  video_sati_24: "24. Los dispositivos de entrenamiento.",
  video_sati_25: "25. Control del flujo inspiratorio.",
  video_sati_26:
    "26. La prescripción farmacéutica y el talonario de prescripción.",
  video_sati_27:
    "27. Prescripción de la cámara A2A y mascarilla de inhalación.",
  video_sati_28: "28. Prescripción de InmunoRespir.",
  video_sati_29: "29. Prescripción para las mucosas orales afectadas.",
  video_sati_30: "30. Encuesta final al paciente.",
  video_sati_31: "31. Generación de informes y próxima cita.",
  video_sati_32: "32. Informe de paciente.",
  video_sati_33: "33. Informe de derivación por flujo insuficiente.",
  video_sati_34: "34. Otros informes de derivación.",
  video_sati_35: "35. Ofrecimiento del servicio en el mostrador.",
  video_sati_36: "36. Programar nuevas citas en la agenda.",
  video_sati_37: "37. Registro de las prescripciones aceptadas.",
  video_sati_38: "38. Sistema de recordatorios y mensajería.",
  video_sati_39: "39. Medidas Covid.",
  video_sati_40: "40. ¿Quién hay detrás de Farmaval?",
  video_sati_41: "41. Elección inhalador principal.",
  video_sati_42: "42. ¿Que ocurre si paciente usa dos inhaladores diferentes?",
  video_sati_43:
    "43. Paciente EPOC e inhalador monodosis polvo seco Handihaler.",
  video_sati_44:
    "44. Paciente EPOC con enfisema pulmonar e inhalador de niebla fina Respimat.",
  video_sati_45: "45. Paciente Asmático e inhalador de polvo seco Turbuhaler.",

  link_sati_1: "https://player.vimeo.com/video/684573034",
  link_sati_2: "https://player.vimeo.com/video/685392520",
  link_sati_3: "https://player.vimeo.com/video/688345206",
  link_sati_4: "https://player.vimeo.com/video/838398122",
  link_sati_5: "https://player.vimeo.com/video/688355173",
  link_sati_6: "https://player.vimeo.com/video/684574347",
  link_sati_7: "https://player.vimeo.com/video/688361792",
  link_sati_8: "https://player.vimeo.com/video/688367203",
  link_sati_9: "https://player.vimeo.com/video/688368760",
  link_sati_10: "https://player.vimeo.com/video/838405767",
  link_sati_11: "https://player.vimeo.com/video/688371703",
  link_sati_12: "https://player.vimeo.com/video/688623093",
  link_sati_13: "https://player.vimeo.com/video/688610397",
  link_sati_14: "https://player.vimeo.com/video/688626444",
  link_sati_15: "https://player.vimeo.com/video/688610899",
  link_sati_16: "https://player.vimeo.com/video/701189206",
  link_sati_17: "https://player.vimeo.com/video/684575488",
  link_sati_18: "https://player.vimeo.com/video/684576687",
  link_sati_19: "https://player.vimeo.com/video/685396491",
  link_sati_20: "https://player.vimeo.com/video/685397299",
  link_sati_21: "https://player.vimeo.com/video/685399122",
  link_sati_22: "https://player.vimeo.com/video/685399333",
  link_sati_23: "https://player.vimeo.com/video/688612675",
  link_sati_24: "https://player.vimeo.com/video/688459718",
  link_sati_25: "https://player.vimeo.com/video/688462696",
  link_sati_26: "https://player.vimeo.com/video/701189730",
  link_sati_27: "https://player.vimeo.com/video/688614103",
  link_sati_28: "https://player.vimeo.com/video/688629258",
  link_sati_29: "https://player.vimeo.com/video/688616792",
  link_sati_30: "https://player.vimeo.com/video/688617394",
  link_sati_31: "https://player.vimeo.com/video/688620317",
  link_sati_32: "https://player.vimeo.com/video/688617623",
  link_sati_33: "https://player.vimeo.com/video/688621404",
  link_sati_34: "https://player.vimeo.com/video/701190158",
  link_sati_35: "https://player.vimeo.com/video/688621835",
  link_sati_36: "https://player.vimeo.com/video/688618095",
  link_sati_37: "https://player.vimeo.com/video/688465095",
  link_sati_38: "https://player.vimeo.com/video/688466020",
  link_sati_39: "https://player.vimeo.com/video/685406481",
  link_sati_40: "https://player.vimeo.com/video/685413171",
  link_sati_41: "https://player.vimeo.com/video/838385660",
  link_sati_42: "https://player.vimeo.com/video/838386868",
  link_sati_43: "https://player.vimeo.com/video/891112561",
  link_sati_44: "https://player.vimeo.com/video/891123647",
  link_sati_45: "https://player.vimeo.com/video/891147645",

  material_sati_1: "1- Estudio EPOCONSUL.",
  material_sati_2: "2- Informe de resultados ASPIRA 2014.",
  material_sati_3:
    "3- Revisión sistemática 2016 sobre errores en terapia inhalada.",
  material_sati_4: "4- Programa SABINA sobreuso SABA.",
  material_sati_5: "5- MiniGEMA5.1.",
  material_sati_6: "6- GINA Pocket Guide 2021.",
  material_sati_7: "7- GESEPOC2021.",
  material_sati_8: "8- Consenso asma pediatría 2021 REGAP.",
  material_sati_9: "9- Dossier formativo.",
  material_sati_10: "10- Algoritmo de resistencias de In-Check Dial.",
  material_sati_11: "11- Tabla de flujos mínimos y óptimos por dispositivo.",
  material_sati_12: "12- Pauta InmunoRespir.",
  material_sati_13: "13- Ofrecimiento del servicio SATI.",
  material_sati_14: "14- Cuestionario para descartar Covid-19.",
  material_sati_15: "15- Proveedores de productos SATI para farmacias.",
  material_sati_16: "16- Modelo solicitud ejercicio derechos del interesado.",
  material_sati_17:
    "17- Consentimiento cesión imágenes y vídeos pacientes SATI.",
  material_sati_18:
    "18- Instrucciones solicitudes del interesado en la Farmacia.",
  material_sati_19: "19- Informe del paciente.",
  material_sati_20: "20- Informe de derivación básico.",
  material_sati_21: "21- Informe de derivación por flujo.",
  material_sati_22: "22- Infografia asma y colageno.",
  material_sati_23: "23- Tabla de flujos óptimos por dispositivo.",
  material_sati_24: "24- Elección inhalador principal. Castellano",
  material_sati_25: "25- Pauta InmunoRespir.",
  material_sati_26: "26- Quecetina.",
  material_sati_27: "27- Mapa mental 3 acciones inhaladores.",

  file_sati_1: "https://www.farmaval.net/docs/1-Estudio%20EPOCONSUL.pdf",
  file_sati_2:
    "https://www.farmaval.net/docs/2-Informe%20de%20resultados%20ASPIRA%202014.pdf",
  file_sati_3:
    "https://www.farmaval.net/docs/3-%20Revisi%C3%B3n%20sistematica%202016%20sobre%20errores%20en%20terapia%20inhalada.pdf",
  file_sati_4:
    "https://www.farmaval.net/docs/4-%20Programa%20SABINA%20sobreuso%20SABA.pdf",
  file_sati_5: "https://www.farmaval.net/docs/5-%20MiniGEMA5.1.pdf",
  file_sati_6:
    "https://www.farmaval.net/docs/6-%20GINA%20Pocket%20Guide%202021.pdf",
  file_sati_7: "https://www.farmaval.net/docs/7-%20GESEPOC2021.pdf",
  file_sati_8:
    "https://www.farmaval.net/docs/8-%20Consenso%20asma%20pediatria%202021%20REGAP.pdf",
  file_sati_9: "https://www.farmaval.net/docs/9-Dossier%20formativo.pdf",
  file_sati_10:
    "https://www.farmaval.net/docs/10-%20Algoritmo%20de%20resistencias%20de%20In-Check%20Dial.pdf",
  file_sati_11:
    "https://www.farmaval.net/docs/11-%20Tabla%20de%20flujos%20m%C3%ADnimos%20y%20%C3%B3ptimos%20por%20dispositivo.pdf",
  file_sati_12: "https://www.farmaval.net/docs/12-%20Pauta%20InmunoRespir.pdf",
  file_sati_13:
    "https://www.farmaval.net/docs/13-%20Ofrecimiento%20del%20servicio%20SATI.pdf",
  file_sati_14:
    "https://www.farmaval.net/docs/14-%20Cuestionario%20para%20descartar%20Covid-19.pdf",
  file_sati_15:
    "https://www.farmaval.net/docs/15-%20Proveedores%20de%20productos%20SATI%20para%20farmacias.pdf",
  file_sati_16:
    "https://www.farmaval.net/docs/16-%20Modelo%20solicitud%20ejercicio%20derechos%20del%20interesado.pdf",
  file_sati_17:
    "https://www.farmaval.net/docs/17-Consentimiento%20cesi%C3%B3n%20imagenes%20y%20videos%20pacientes%20SATI%20.pdf",
  file_sati_18:
    "https://www.farmaval.net/docs/18-Instrucciones%20solicitudes%20del%20intereado%20en%20la%20Farmacia.pdf",
  file_sati_19: "https://www.farmaval.net/docs/19-Informe%20del%20paciente.pdf",
  file_sati_20:
    "https://www.farmaval.net/docs/20-%20Informe%20de%20derivaci%C3%B3n%20b%C3%A1sico.pdf",
  file_sati_21:
    "https://www.farmaval.net/docs/21-%20Informe%20de%20derivaci%C3%B3n%20por%20flujo.pdf",
  file_sati_22:
    "https://www.farmaval.net/docs/22-%20Infografia%20asma%20y%20colageno.pdf",
  file_sati_23:
    "https://www.farmaval.net/docs/23-%20Tabla%20de%20flujos%20%C3%B3ptimos%20por%20dispositivo.pdf",
  file_sati_24:
    "https://www.farmaval.net/docs/24-%20Elecci%C3%B3n%20inhalador%20principal.pdf",
  file_sati_25: "https://www.farmaval.net/docs/25-%20Pauta%20InmunoRespir.pdf",
  file_sati_26: "https://www.farmaval.net/docs/26-%20Quecetina.pdf",
  file_sati_27:
    "https://www.farmaval.net/docs/27-%20Mapa%20mental%203%20acciones%20inhaladores.pdf",

  // Calendar
  calendar_dates: "Citas",
  calendar_follow: "Seguimiento",
  calendar_cepoc: "Candidatos CEPOC",
  cepoc_filter_name: "Nombre del paciente",
  cepoc_filter_date_from: "Desde",
  cepoc_filter_date_to: "Hasta",
  cepoc_filter_btn: "Filtrar",
  cepoc_clear_btn: "Limpiar",
  cepoc_col_name: "Nombre",
  cepoc_col_phone: "Teléfono",
  cepoc_col_date: "Fecha",
  cepoc_no_results: "No hay candidatos registrados.",
  cepoc_col_actions: "Acciones",
  cepoc_btn_delete: "Eliminar",
  cepoc_confirm_delete: "¿Está seguro de eliminar este candidato?",
  day_1: "Lu",
  day_2: "Ma",
  day_3: "Mi",
  day_4: "Ju",
  day_5: "Vi",
  day_6: "Sá",
  day_7: "Do",
  calendar_months:
    "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
  date_btn_add: "Añadir cita",
  date_btn_update: "Actualizar",
  date_btn_delete: "Eliminar",
  date_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
  date_confirm_delete_text: "eliminar",

  date_no_shift: "No hay",

  date_popup_title: "Programar cita",
  date_lbl_patient: "Paciente",
  date_lbl_staff: "Persona que agenda el servicio",
  date_lbl_service: "Servicio",
  date_lbl_date: "Fecha",
  date_lbl_time: "Hora",
  date_lbl_phone: "Teléfono",
  date_lbl_comment: "Comentario",
  date_btn_cancel: "Cancelar",

  // General

  result_ok: "Operación realizada",
  error_empty_fields: "Datos incorrectos",
  error_operation: "Error en la operación",

  error_params: "100",
  error_query: "101",

  btn_new: "Nuevo",
  btn_add: "Añadir",
  btn_update: "Actualizar",
  btn_delete: "Eliminar",

  // Pending
  pending_info:
    "Hay documentación que debe ser revisada y firmada antes de iniciar el servico y tener acceso a toda la funcionalidad de la aplicación.<br><br>Por favor, rellene todos los campos de los siguientes formularios y revise y firme los documentos:",
  pending_data: "Documentos pare revisar y firmar",
  pending_agreement_service_form: "Datos para implantación",
  pending_agreement_sepa_form: "Datos para SEPA",
  pending_agreement_service: "Contrato de implantación",
  pending_agreement_service_info: "Términos y condiciones del servicio.",
  pending_agreement_sepa: "Orden de domiciliación SEPA",
  pending_agreement_sepa_info:
    "Documento para que su banco acepte los recibos emitidos por Farmaval.",
  pending_type_admin: "Administrador",
  pending_type_owner: "Titular",
  pending_lbl_pharm_name: "Nombre de la farmacia",
  pending_lbl_address: "Dirección",
  pending_lbl_city: "Municipio",
  pending_lbl_state: "Comunidad autónoma",
  pending_lbl_nif: "CIF o NIF de empresa",
  pending_lbl_signer_type: "En calidad de:",
  pending_lbl_signer_dni: "DNI",
  pending_lbl_signer_name: "Nombre del firmante",

  pending_lbl_debtor_name: "Nombre del deudor",
  pending_lbl_debtor_city: "Población",
  pending_lbl_debtor_state: "Provincia",
  pending_lbl_debtor_country: "País",
  pending_lbl_debtor_swift: "Swift BIC",
  pending_lbl_debtor_iban: "Número de cuenta-IBAN",

  btn_pending_service: "Revisar y firmar documentos",
  btn_pending_sepa: "Revisar y firmar orden",

  pending_months:
    "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",

  pending_upload: "Enviar documentación",
  pending_again: "Volver a firmar",

  checking_data: "Documentos en revisión",
  checking_msg:
    "Se está revisando la documentación.<br><br>Tan pronto como estén confirmados los datos, se les avisará para empezar con la formación del equipo.<br><br>Gracias.",

  // Profile
  settings_title_info: "Información",
  settings_title_pharm: "Datos",
  settings_title_admin: "Titular",
  settings_title_staff: "Equipo",
  settings_title_drugs: "Productos",
  settings_title_probiotics: "Probióticos",
  settings_title_calendar: "Días de servicio",
  settings_title_syncro: "Sincronización",

  // Probióticos de farmacia — Etapa 05
  profile_probiotics_cn: "Código Nacional",
  profile_probiotics_pvp: "PVP (€)",
  profile_probiotics_name: "Nombre",
  profile_probiotics_lab: "Laboratorio",
  profile_probiotics_strains: "Cepas",
  profile_probiotics_format: "Presentación",
  profile_probiotics_actions: "Acciones",
  profile_probiotics_in_matrix: "En guía",
  profile_probiotics_in_matrix_yes: "✓ Sí",
  profile_probiotics_not_in_matrix: "⚠ No",
  profile_probiotics_lookup: "Buscar",
  profile_probiotics_add: "Añadir probiótico",
  profile_probiotics_warning:
    "Probiótico no encontrado en la guía. Se ha notificado al equipo Curasui.",
  profile_probiotics_found:
    "✓ Encontrado en la guía — datos cargados automáticamente",
  profile_probiotics_not_found_manual:
    "⚠ No encontrado en la guía — completa los datos mínimos para notificar al equipo",
  profile_probiotics_saved: "Probiótico añadido correctamente.",
  profile_probiotics_saving: "Guardando…",
  profile_probiotics_deleting: "Eliminando…",
  btn_activate: "Activar",
  btn_deactivate: "Desactivar",

  // Personal
  staff_lbl_name: "Nombre",
  staff_lbl_title: "Categoría",
  staff_lbl_code: "Nº colegiado",
  staff_lbl_date: "Fecha",
  staff_lbl_comment: "Comentario",
  staff_lbl_active: "Estado",
  staff_lbl_sati: "Líder/Responsable",

  staff_title_0: "Auxiliar",
  staff_title_1: "Técnico",
  staff_title_2: "Farmaceútico",
  staff_title_3: "Titular",
  staff_title_4: "Otro",
  staff_active_0: "Inactivo",
  staff_active_1: "Activo",

  staff_sati_0: "Responsable",
  staff_sati_1: "Líder",

  staff_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
  staff_confirm_delete_text: "eliminar",

  // días de servicio
  day_lbl_name: "Día",
  day_lbl_from: "Desde",
  day_lbl_to: "Hasta",
  day_lbl_comment: "Comentario",
  day_name_0: "Lunes",
  day_name_1: "Martes",
  day_name_2: "Miércoles",
  day_name_3: "Jueves",
  day_name_4: "Viernes",
  day_name_5: "Sábado",
  day_name_6: "Domingo",
  day_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
  day_confirm_delete_text: "eliminar",

  // productos
  prod_lbl_name: "Nombre (castellano)",
  prod_lbl_info: "Información (castellano)",
  prod_lbl_name_ca: "Nombre (catalán)",
  prod_lbl_info_ca: "Información (catalán)",
  prod_lbl_price: "Precio",
  prod_lbl_service: "Servicio",
  prod_lbl_creator: "Creador",
  prod_lbl_state: "Estado",
  prod_state_0: "Inactivo",
  prod_state_1: "Activo",
  prod_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
  prod_confirm_delete_text: "eliminar",
  pp_confirm_delete: "¿Eliminar este probiótico de tu lista?",

  // farmacia
  pharm_lbl_name: "Nombre",
  pharm_lbl_business: "Razón social",
  pharm_lbl_nif: "CIF",
  pharm_lbl_address: "Dirección",
  pharm_lbl_city: "Ciudad",
  pharm_lbl_state: "Provincia",
  pharm_lbl_postal: "Código postal",
  pharm_lbl_email: "Email",
  pharm_lbl_phone: "Teléfono fijo",
  pharm_lbl_mobile: "Teléfono móvil",
  pharm_lbl_web: "Web",

  pharm_lbl_admin_name: "Nombre",
  pharm_lbl_admin_code: "Nº colegiado",
  pharm_lbl_admin_email: "Email",
  pharm_lbl_admin_signature: "Firma",
  pharm_lbl_admin_password: "Contraseña",

  pharm_lbl_user: "Usuario",
  pharm_lbl_password: "Contraseña",
  pharm_password_empty: "Dejar vacío para no cambiar",

  pharm_lbl_language: "Idioma",
  pharm_lbl_password: "Contraseña",
  pharm_lbl_logo: "Logo para informes (aspecto 3/1)",
  pharm_lbl_schedule: "Horario",

  pharm_lbl_schedule_0: "Ininterrumpido",
  pharm_lbl_schedule_1: "Partido",
  pharm_lbl_schedule_2: "24 horas",

  day_btn_add: "Añadir horario",
  day_btn_delete: "Eliminar",
  question_remove_day: "Eliminar horario de servicio: ",
  error_loading_days: "Problema al cargar días disponibles.",
  error_removing_day: "No se ha podido eliminar el horario.",
  error_adding_day: "No se ha podido añadir el horario.",

  // PDF viewer
  pdf_close: "Cerrar informe",

  // Popup
  popup_ok: "Aceptar",
  popup_close: "Cerrar",
  popup_cancel: "Cancelar",

  // Index
  new_link_more: "Más información",

  // Index config products
  products_lbl_list: "Productos disponibles",
  products_lbl_service: "Servicio",
  error_loading_products: "Problema al cargar los productos.",
  product_lbl_name: "Producto",
  product_lbl_info: "Información",
  product_lbl_cost: "Precio",
  product_lbl_cn: "CN",

  product_btn_add: "Añadir",
  product_btn_edit: "Modificar",
  product_btn_delete: "Borrar",

  product_msg_empty: "Deben rellenarse todos los cmapos.",
  product_msg_cost: "El precio no es un valor correcto.",
  product_msg_error: "Se ha producido un problema al realizar la operación.",

  product_question_edit: "¿Modificar el producto seleccioando?",
  product_question_delete: "¿Eliminar el producto seleccionado?",

  // Index config days

  // Index calendar
  calendar_days: "Lu,Ma,Mi,Ju,Vi,Sá,Do",
  calendar_times: "Horarios: ",
  calendar_no_times: "No hay",

  calendar_date_title: "Citas del día ",
  calendar_no_dates: "No hay citas",
  btn_cancel_date: "cancelar",
  btn_edit_date: "editar",

  lbl_date_phones: "Tels:",
  new_date_text: "Añadir cita el día:",
  new_date_lbl_patient: "Paciente",
  new_date_lbl_staff: "Técnico/a",
  new_date_lbl_service: "Servicio",
  new_date_lbl_date: "Fecha",
  new_date_lbl_time: "Hora",
  new_date_lbl_phone: "Teléfono",
  new_date_lbl_comment: "Comentario",
  new_date_error_empty: "Faltan datos por rellenar",
  new_date_error_server: "Error al añadir la cita",
  new_date_confirm_remove: "Eliminar cita de ",
  error_loading_date: "Error cargando datos",

  // News y Mensajes
  error_loading_news: "No se ha podido cargar las noticias.",
  lbl_loading_news: "Cargando noticias...",
  loading_reports: "Cargando datos...",
  title_news: "Noticias",

  // Reports

  reports_group_respiratory: "Respiratorios",
  reports_group_digestive: "Probióticos",
  reports_list: "Servicios",
  reports_staff: "Equipo",
  reports_stats: "Informes SATI",
  reports_stats_iretia: "Informes IRETIA",
  reports_dosing: "Intervenciones de Pauta",

  filter_dosing_drug: "Medicamento",
  filter_dosing_patient: "Paciente",
  filter_dosing_state: "Estado",
  filter_dosing_state_all: "Todas",
  filter_dosing_state_active: "Activas",
  filter_dosing_state_deleted: "Eliminadas",
  filter_dosing_correction: "Resultado",
  filter_dosing_correction_all: "Todas",
  filter_dosing_correction_correct: "Correctas",
  filter_dosing_correction_adjusted: "Ajustadas",
  lbl_dosing_caption: "Intervenciones de pauta",
  lbl_dosing_drug: "Medicamento",
  lbl_dosing_patient: "Paciente",
  lbl_dosing_staff: "Técnico",
  lbl_dosing_doctor_doses: "Pauta médica",
  lbl_dosing_patient_doses: "Pauta paciente",
  lbl_dosing_status: "Estado",
  dosing_delete_popup_title: "Dar de baja intervención de pauta",
  dosing_delete_reason_label: "Motivo de la baja",
  lbl_dosing_monthly_margin: "Margen mensual (€)",
  lbl_dosing_annual_margin: "Margen anual (€)",
  lbl_dosing_accepts: "Acepta corrección",
  dosing_col_actions: "Acciones",
  dosing_status_over: "Sobre dosificado",
  dosing_status_under: "Sub dosificado",
  dosing_status_correct: "Correcto",
  dosing_accepts_yes: "Sí",
  dosing_accepts_no: "No",
  dosing_confirm_delete: "¿Está seguro de eliminar esta intervención de pauta?",

  lbl_report_staff_name: "Nombre",
  lbl_report_staff_SATI: "SATI",
  lbl_report_staff_IRETIA: "IRETIA",
  lbl_report_staff_CEPOC: "CEPOC",
  lbl_report_staff_dates_count: "Citas mostrador",
  lbl_report_staff_dates_service_count: "Citas servicio",
  lbl_report_staff_last_service: "Último servicio",
  lbl_report_staff_last_date: "Última cita",
  lbl_report_staff_active: "Estado",
  lbl_report_staff_state_active: "Activo",
  lbl_report_staff_state_noactive: "Inactivo",

  lbl_report_type: "Servicio",
  lbl_report_date: "Fecha",
  lbl_report_name: "Nombre",
  lbl_report_staff: "Técnico",
  lbl_report_sales: "Ventas",
  lbl_report_main: "Inhalador",
  lbl_report_visit: "Visita In.",
  lbl_report_visit_real: "Visita",

  filter_service: "Servicio",
  filter_from: "Desde",
  filter_to: "Hasta",
  filter_patient: "Apellidos paciente",
  filter_btn: "Mostrar",
  filter_type_all: "Todos",
  filter_type_sati: "SATI",
  filter_type_iretia: "IRETIA",
  filter_type_cepoc: "CEPOC",
  filter_type_deleted: "Eliminados",

  report_popup_title: "Editar servicio",
  report_lbl_comment: "Comentario",
  report_lbl_sales: "Ventas",
  report_lbl_product_type: "Producto",
  report_lbl_product_name: "Nombre",
  report_lbl_product_cost: "Coste",
  report_lbl_product_quantiy: "Cantidad",

  report_btn_update: "Actualizar",
  report_btn_recover: "Recuperar",
  report_btn_delete: "Eliminar",
  report_btn_remove: "Eliminar definitivamente",
  report_btn_cancel: "Cancelar",

  report_btn_view_patient: "Informe del paciente",
  report_btn_view_doctor: "Informe derivación médico",

  report_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
  report_confirm_delete_text: "eliminar",

  report_confirm_remove:
    "Teclee <b>eliminar definitivamente</b> y pulse 'Eliminar definitivamente':",
  report_confirm_remove_text: "eliminar definitivamente",

  report_sale_remove: "Quitar",
  report_sale_add: "Añadir",

  // Pacientes

  patients_list: "Consulta",
  patients_followup: "Seguimiento",
  filter_patient_name: "Apellidos del paciente",
  filter_patient_order: "Ordenar por",
  filter_patient_order_name: "Apellidos",
  filter_patient_order_next_visit: "Próxima visita",

  col_patient_name: "Paciente",
  col_patient_com_mode: "Comunicaciones",
  col_patient_contact: "Contacto",
  col_patient_lng: "Idioma",
  col_patient_visits: "Visitas",
  col_patient_next_visit: "Próxima visita",
  patient_contact_email: "Email",
  patient_contact_call: "Llamada",
  patient_contact_sms: "SMS",

  patient_tab_basic: "Datos básicos",
  patient_tab_com: "Comunicaciones",
  patient_tab_clinic: "Médico",

  patient_popup_title: "Editar paciente",
  patient_lbl_dni: "DNI",
  patient_lbl_name: "Nombre",
  patient_lbl_surname_1: "Primer apellido",
  patient_lbl_surname_2: "Segundo apellido",
  patient_lbl_date: "Fecha de nacimiento",
  patient_lbl_sex: "Sexo",
  patient_lbl_smoker: "Fumador",
  patient_lbl_town: "Población",
  patient_lbl_postal: "Código postal",
  patient_lbl_com_mode: "Comunicaciones",
  patient_lbl_phone: "Teléfono (llamada)",
  patient_lbl_mobile: "Teléfono (SMS)",
  patient_lbl_email: "Email",
  patient_lbl_language: "Idioma",
  patient_lbl_doctor_genere: "Dr./Dra.",
  patient_lbl_doctor: "Médico de cabecera",
  patient_lbl_center: "Centro médico",
  patient_lbl_comment: "Posibles sustituciones a la derivación por flujo",

  patient_value_yes: "Sí",
  patient_value_no: "No",
  patient_value_man: "Masculino",
  patient_value_woman: "Femenino",
  patient_value_dr: "Doctor",
  patient_value_dra: "Doctora",

  patient_btn_delete: "Eliminar paciente",
  patient_btn_new: "Nuevo paciente",
  patient_btn_add: "Registrar paciente",
  patient_btn_update: "Actualizar datos",
  patient_btn_cancel: "Cancelar",
  patient_btn_history: "Ver historial",

  patient_confirm_delete:
    "¡Atención! Utilice esta opción sólo si es un paciente de pruebas. Para confirmar, teclee <b>eliminar</b> y pulse 'Eliminar':",
  patient_confirm_delete_text: "eliminar",

  // Sincronización

  syncro_lbl_data: "Datos almacenados localmente",
  syncro_lbl_value: "Total",
  syncro_data_staff: "Equipo de la farmacia",
  syncro_data_drugs: "Medicamentos",
  syncro_data_days: "Días de servicio",
  syncro_data_products: "Productos",
  syncro_data_services: "Servicios",

  syncro_lbl_date: "Última actualiación",

  syncro_lbl_services: "Lista de servicios pendientes",
  syncro_data_services_none: "Ninguno",
  btn_syncro_now: "Sincronizar ahora",

  // stats
  btn_stats_print: "Imprimir",
  stats_title_report: "Servicio de Acompañamiento en Terapia Inhalada",
  stats_from: "Informes desde ",
  stats_to: " hasta ",
  stats_financial_title: "Datos financieros económicos",
  stats_visit_all: "Todas las visitas",
  stats_visit_1: "Primera visita",
  stats_visit_2: "Segunda visita",
  stats_visit_3: "Tercera visita y posteriores",
  stats_title_services: "Servicios",
  stats_title_time: "Duración",
  stats_title_time_per: "Duración por servicio",
  stats_title_sales: "Ventas",
  stats_title_sales_per: "Ventas por servicio",
  stats_prescription: "Abordajes",
  stats_title_prescription: "Servicios con al menos un abordaje",
  stats_title_prescription_per: "% de servicios",
  stats_sales: "Productos vendidos",
  stats_title_quantity: "Cantidad",
  stats_title_total: "Total",
  stats_all_staff: "Total",
  stats_farmaval: "Media Farmaval",

  chart_services: "Servicios totales",
  chart_time_avg: "Tiempo medio por servicio",
  chart_prescriptions: "Abordajes (ventas)",
  chart_prescriptions_service: "Abordajes por servicio",
  chart_media: "Farmaval: Media",
  chart_best: "Farmaval: Mejores",
  chart_pharm: "Farmacia",
  chart_visits: "Todas las visitas",
  chart_visit_1: "Primera visita",
  chart_visit_2: "Segunda visita",
  chart_visit_3: "Tercera visita y posteriores",

  stats_col_visits: "Visitas",
  stats_col_staff: "Equipo",
  stats_col_product: "Producto",
  stats_col_indicator: "Indicador",
  stats_col_error: "Error",

  stats_dosing_title: "Intervenciones de pauta",
  stats_dosing_accepted_subtitle: "Pautas aceptadas por los pacientes",
  stats_dosing_missing_subtitle: "Pautas no aceptadas por los pacientes",
  stats_dosing_item: "Item",
  stats_dosing_value: "Valor",
  stats_dosing_corrections: "Número de intervenciones de pauta",
  stats_dosing_monthly_revenue: "Facturación total mensual",
  stats_dosing_monthly_margin: "Margen total mensual",
  stats_dosing_annual_revenue: "Facturación anualizada",
  stats_dosing_annual_margin: "Margen anualizado",
  stats_dosing_top_drugs: "Medicamentos principales",
  stats_dosing_drug_name: "Medicamento",
  stats_dosing_drug_format: "Formato",
  stats_dosing_drug_monthly_revenue: "Facturación mensual",
  stats_dosing_drug_monthly_margin: "Margen mensual",
  stats_dosing_drug_annual_revenue: "Facturación anualizada",
  stats_dosing_drug_annual_margin: "Margen anualizado",

  stats_medical_title: "Datos asistenciales",
  stats_technique: "Mejora en la técnica inhalada",
  stats_asma: "Datos de asma",
  stats_asma_kids: "Datos de asma infantil",
  stats_epoc: "Datos de EPOC",
  stats_aco: "Datos de ACO",

  stats_medical_services: "Número de servicios",
  stats_points_asma:
    "Puntuación media<br><small>5 mal control -> 25 buen control</small>",
  stats_points_asma_kids:
    "Puntuación media<br><small>0 mal control -> 27 buen control</small>",
  stats_points_epoc:
    "Puntuación media<br><small>40 impacto muy alto -> 0 impacto bajo</small>",
  stats_points_aco:
    "Puntuación media<br><small>40 impacto muy alto -> 0 impacto bajo</small>",
  stats_control_perfect: "Control total",
  stats_control_good: "Control bueno",
  stats_control_bad: "No controlado",
  stats_control_ok: "Controlado",
  stats_control_ko: "No controlado",

  stats_impact_low: "Impacto bajo",
  stats_impact_middle: "Impacto medio",
  stats_impact_high: "Impacto alto",
  stats_impact_higher: "Impacto muy alto",

  stats_errors: "Errores más comunes",

  stats_medical_visits: "Visitas",
  stats_medical_visit_1: "Visita 1ª",
  stats_medical_visit_2: "Visita 2ª",
  stats_medical_visit_3: "Visita >2ª",
  stats_medical_improvment: "Mejora",
  stats_medical_quantity: "Cantidad",

  stats_medical_info:
    "Los cálculos de control de enfermedad se realizan sólo con los datos de la tres primeras visitas. Los resultados de las siguientes visitas de seguimiento no se tienen en cuenta.",

  stats_technique_pharm: "Media de errores en técnica",
  stats_technique_media: "Media Farmaval",

  stats_help_chart_services:
    "Compara el nº de servicios SATI de la farmacia con la media y los mejores de Farmaval, por tipo de visita.",
  stats_help_chart_times:
    "Tiempo medio por servicio en minutos (mín. 10 min por servicio). Menor tiempo = mejor en la columna Mejores.",
  stats_help_dosing_accepted:
    "Impacto económico de correcciones de pauta aceptadas (infra-dosificación): total mensual y proyección anual (×12).",
  stats_help_dosing_missing:
    "Mismo cálculo para pautas no aceptadas: oportunidad económica no capturada.",
  stats_help_financial_visit:
    "Por empleado: nº servicios, duración total y media, ventas totales y por servicio. Fila Total = farmacia. Filtrado por el tipo de visita del título.",
  stats_help_chart_prescriptions:
    "Compara ventas totales (€) asociadas a servicios SATI vs media y mejores Farmaval, por visita.",
  stats_help_chart_prescriptions_service:
    "Compara ventas medias por servicio (€) vs media y mejores Farmaval, por visita.",
  stats_help_prescriptions:
    "Servicios con al menos una venta registrada y % sobre el total de servicios del periodo (todas las visitas).",
  stats_help_sales:
    "Productos vendidos en servicios SATI: unidades e importe (€), ordenados por total.",
  stats_help_technique:
    "Media de errores de técnica por visita y % de mejora al bajar errores entre visitas. Compara farmacia vs media Farmaval.",
  stats_help_asma:
    "Asma adulta (≥12): nº servicios, puntuación media ACT y % control total (25), bueno (20–24) y no controlado (5–19) por visita.",
  stats_help_asma_kids:
    "Asma infantil (<12): nº servicios, puntuación media C-ACT y % controlado (≥20) / no controlado (0–19) por visita.",
  stats_help_epoc:
    "EPOC: nº servicios, puntuación media CAT y % por impacto (bajo 0–10, medio 11–20, alto 21–30, muy alto 31–40).",
  stats_help_aco:
    "ACO: misma lectura que EPOC con puntuación CAT y tramos de impacto.",
  stats_help_errors:
    "Los 8 errores de técnica inhalatoria más frecuentes en el periodo (solo servicios con errores detectados).",

  // stats IRETIA
  stats_pharm: "Farmacia",
  stats_farmaval: "Farmaval",
  stats_iretia_title_report:
    "Servicio de intervención rápida en terapia inhalada aguda",

  stats_iretia_title_1: "Datos generales",
  stats_iretia_title_2: "Perfil pacientes",
  stats_iretia_title_3: "Diagnósticos",
  stats_iretia_title_4: "Inahaladores más dispensados",
  stats_iretia_title_5: "Errores más comunes",
  stats_iretia_title_6: "Prestación de servicio por miembro del equipo",

  stats_iretia_col_1: "Mi farmacia",
  stats_iretia_col_2: "Media farmacias Farmaval",
  stats_iretia_col_3: "Farmacia más activa",

  stats_iretia_1: "Número servicios IRETIA prestados",
  stats_iretia_2: "Tiempo medio invertido por servicio (minutos)",
  stats_iretia_3: "Total ventas asociadas servicio",
  stats_iretia_4: "Media de ventas por servicio",
  stats_iretia_5: "Servicios con ventas asociadas",
  stats_iretia_6: "Media de errores",
  stats_iretia_7: "Servicios con al menos 1 error en la técnica",
  stats_iretia_8: "Valoración muy útil del servicio",
  stats_iretia_9: "Valoración compromiso muy alto de la farmacia",

  stats_iretia_8_3: "No lo sabe",
  stats_iretia_8_0: "Bronquitis aguda",
  stats_iretia_8_7: "Bronquitis asmática",
  stats_iretia_8_1: "Neumonía",
  stats_iretia_8_2: "Covid o Post Covid",
  stats_iretia_8_5: "Cardiovascular",
  stats_iretia_8_9: "Resfriado común",
  stats_iretia_8_10: "Gripe",
  stats_iretia_8_6: "Otro",

  stats_iretia_9_1: "Mujeres",
  stats_iretia_9_2: "Media edad",
  stats_iretia_9_3: "Fumadores",
  stats_iretia_9_4: "Ex fumador",
  stats_iretia_9_5: "Fumador pasivo",
  stats_iretia_9_6: "No fumador",

  stats_iretia_first: "1º",
  stats_iretia_second: "2º",
  stats_iretia_third: "3º",

  stats_iretia_team_1: "Servicios",
  stats_iretia_team_2: "Tiempo medio",
  stats_iretia_team_3: "Ventas",
  stats_iretia_team_4: "Media de ventas",
  stats_iretia_team_5: "Servicios con ventas",

  stats_iretia_products: "Productos vendidos",
  stats_iretia_product_qty: "Cantidad",
  stats_iretia_product_total: "Total",

  // ******************************************
  // Settings

  settings_info_drugs: "Gestión de productos recomendados para los servicios.",
  settings_info_calendar:
    "Selección de días hábiles por defecto para la realización de servicios.",
  settings_info_syncro: "Información sobre los datos guardados localmente.",
  settings_info_pharm:
    "Opciones generales relativas al aplicativo y a la farmacia.",
  settings_lbl_signature: "Firma del titular",
  settings_lbl_version: "Versión aplicativo",
  settings_lbl_pharm: "Farmacia",
  settings_lbl_disabled: "En desarrollo",
  settings_lbl_noactive: "No activado",
  error_loading_pharm: "Problema al cargar los datos de la farmacia",

  no_signature_msg:
    "El sistema no dispone de una firma del titular de la farmacia, necesaria para firmar los informes.<br><br/>Puede establecerse desde la sección de configuración.",
  no_passwords_msg:
    "Falta la contraseña de acceso. Por favor, establezca la contraseña desde la sección de configuración.",
  no_signature_passwords_msg:
    "El sistema no dispone de una firma del titular de la farmacia, necesaria para firmar los informes, ni tampoco de contraseña de acceso.<br><br/>Pueden establecerse desde la sección de configuración.",

  settings_btn_new_signature: "Nueva firma",
  signature_pharm_title: "Firma del titular de la farmacia",

  settings_password_public_lbl: "Contraseña de acceso",
  settings_password_public_info:
    "Está asociada al usuario/email de la farmacia y permite acceder al aplicativo y realizar servicios.",
  warning_nopassword: "¡Atención! no hay contraseña.",
  btn_new_password: "Establecer contraseña",
  btn_change_password: "Cambiar contraseña",
  new_password_must_1: "Más de 7 carácteres.",
  new_password_must_2: "Incluir letras.",
  new_password_must_3: "Incluir números.",
  new_password_must_4: "Incluir símbolos.",
  new_password_must_5: "Confirmar contraseña.",
  new_password_value: "Nueva contraseña",
  new_password_repeat: "Confirmar contraseña",
  new_password_public_title: "Cambiar la contraseña de técnicos",
  new_password_error:
    "Error al intentar asignar la contraseña. Por favor, inténtalo de nuevo.",
  new_password_notallowed:
    "Un usuario técnico no puede cambiar las contraseñas. Por favor, inicie sesión como administrador.",

  // Service
  signature_title_modal:
    "Recogida de datos para la prestación del servicio SATI",
  signature_text_check1:
    "AUTORIZO el uso de mis datos para la prestación del servicio Acompañamiento en Terapia Inhalada.",
  signature_text_check2:
    "AUTORIZO el uso de mis datos para la realización de comunicaciones telemáticas (SMS, mensajes, E-mail, etc.)",
  signature_text_check3:
    "AUTORIZO el uso de mis datos para la realización de estudios de investigación asistencial.",
  signature_text_check4:
    "AUTORIZO a la farmacia a compartir con el médico que me trata la información sobre el tratamiento inhalado que tomo con el fin de mejorar mis resultados terapéuticos.",

  signature_image_title_modal:
    "Consentimiento explícito para la publicación y el tratamiento de imágenes general",
  signature_image_radio1: "AUTORIZO el uso de las imágenes",
  signature_image_radio2: "NO AUTORIZO el uso de las imágenes.",

  signature_label_patient:
    "Al ser menor, escribe el nombre de la persona responsable",
  signature_btn_clear: "Empezar de nuevo",
  signature_btn_ok: "Aceptar",
  signature_btn_cancel: "Cancelar",
  signature_error:
    "No se ha podido almacenar la nueva firma, por favor inténtelo de nuevo.",

  service_error_unknown: "El servicio no existe",
  service_error_loading: "Error cargando servicios",
  service_error_patient: "Error cargando formulario de paciente",
  service_error_staff: "Error cargando datos de los responsables",
  service_error_service: "Error cargando datos del servicio",

  service_btn_cancel: "Cancelar servicio",
  service_btn_prev: "Atrás",
  service_btn_next: "Siguiente",
  tab_start_title: "Inicio de servicio",
  tab_start_info:
    "Seleccione el técnico que realizará el servicio y rellene la ficha del paciente. Si el paciente ya está registrado puede buscarlo por el DNI o sus apellidos.",
  tab_start_info_iretia:
    "Seleccione el técnico que realizará el servicio y rellene los datos del paciente. En caso de cesión de derechos de imagen, rellene el DNI, nombre y apellidos.",
  tab_start_staff_info: "Técnico del servicio",

  lbl_question_cancel:
    "¿Seguro que quiere cancelar el servicio? No se guardará ningún dato.",

  lbl_question_new: "Escriba el nombre del nuevo técnico:",
  lbl_question_update: "Escriba el nuevo nombre del técnico:",
  lbl_question_delete: "¿Seguro que quiere eliminar el técnico seleccionado?",

  btn_staff_delete: "Eliminar seleccionado",
  btn_staff_update: "Modificar",
  btn_staff_new: "Nuevo",

  tab_start_patient_info: "Ficha del paciente",
  lbl_patient_search: "Buscando paciente...",
  lbl_patient_new: "Nuevo paciente",
  lbl_patient_error: "Error en servidor",
  lbl_patient_dni: "DNI",
  lbl_patient_name: "Nombre",
  lbl_patient_surname_1: "Primer apellido",
  lbl_patient_surname_2: "Segundo apellido",
  lbl_patient_date: "Fecha de nacimiento",
  lbl_patient_age: "Edad",
  lbl_patient_sex: "Sexo",
  lbl_patient_smoke: "Fumador",

  lbl_patient_extra: "Datos sólo si el paciente cede derechos de imagen",

  options_patient_sex: "Mujer/1,Hombre/0",
  options_patient_smoke: "No/0,Sí/1",

  lbl_patient_studies: "Estudios",
  lbl_patient_tsi: "TSI",
  options_patient_studies:
    "Sin estudios/0,Básicos/1,Bachillerato/2,Grado técnico/3,Universitarios/4",

  lbl_patient_town: "Población",
  lbl_patient_postal: "Código postal",
  lbl_patient_phone: "Teléfono fijo (llamada)",
  lbl_patient_mobile: "Móvil (SMS)",
  lbl_patient_contact: "Teléfono Móvil",
  lbl_patient_email: "Email",
  lbl_patient_com_mode: "Comunicaciones",
  lbl_patient_lang: "Idioma",
  options_patient_com_mode: "Por email/0,Por llamada/1,Por SMS/2",
  options_patient_lang: "Castellano/es,Català/ca",

  lbl_patient_doctor_genere: "Dr/Dra",
  options_patient_doctor_genere: "Dr./0,Dra./1",
  lbl_patient_doctor: "Médico de cabecera",
  lbl_patient_center: "Centro médico",
  lbl_patient_comment: "Posibles sustituciones a la derivación por flujo",

  lbl_patient_sign: "Firma del paciente",

  section_patient_title: "Datos básicos del paciente",
  section_patient_info:
    "Rellene los datos si es nuevo paciente o actualízalos si es necesario",

  form_error_staff: "Seleccione tu nombre como responsable del servicio",
  form_error_required: "Faltan datos por rellenar",
  form_error_pattern: "El formato no es el correcto",
  form_error_contact: "Debe rellenar el dato de contacto.",
  form_error_options: "Hay preguntas del cuestionario sin responder.",

  // 0.7.3
  title_chat: "Contacto",
  info_chat: "Puede enviarnos un correo directamente desde aquí.",
  placeholder_chat: "Mensaje a enviar",
  btn_chat_send: "Enviar",
  email_ok: "Gracias, le responderemos lo antes posible.",
  email_error:
    "No hemos podido enviar el correo, por favor inténtelo de nuevo o póngase en contacto con nosotros a través de farmaval.net",

  // 0.7.5
  rep_title_change: "Servicio a: ",
  rep_comment: "Comentario",
  rep_btn_patient: "Informe paciente",
  rep_btn_doctor: "Informe médico",
  rep_btn_delete: "Eliminar servicio",
  rep_btn_remove: "Eliminar definitivamente",
  rep_btn_confirm: "Confirmar eliminar",
  rep_btn_save: "Actualizar",
  rep_btn_restore: "Restaurar",
  rep_sales: "Productos vendidos",
  rep_products: "Productos",
  rep_prod_name: "Nombre",
  rep_prod_cost: "Precio",
  rep_prod_qty: "Cantidad",
  rep_prod_add: ">>",
  rep_prod_other: "Otro",
  rep_result_error: "Error realizando operación",
  rep_result_notallowed: "Sólo el titular puede eliminar registros.",

  service_error_loading_data:
    "Ha habido un error actualizando los datos para inciar el servicio.",
  service_error_local_data:
    "No se han podido cargar los datos para iniciar el servicio. Asegúrese que hay conexión a Internet y vuelva a intentarlo.",
  service_warning_local_data:
    "Los datos para iniciar el servicio puede que estén desactualizados",

  service_online: "Conectado",
  service_offline: "Sin conexión",

  end_reports_question: "Confirme que se cierra el servicio.",
  end_error_reports: "Problema al generar informes y almacenar el servicio.",
  end_error_reports_backup:
    "Problema al guardar el servicio. Se va a almacenar de forma local para no perder los datos.<br><br>Puede realizar la sincronización con el servidor desde la sección de configuración.",

  // Probiomentor — Material divulgativo y formación
  probio_formation_btn: "Acceder a Probio Experts",
  probio_formation_sub: "Formación especializada en probióticos",
  probio_material_title: "Material Probio Mentor",
  probio_material_subtitle: "Descarga flyers y posts para redes sociales",

  // Mensajes de Probio
  probio_loading: "Generando acceso seguro...",
  error_probio_link:
    "No se pudo generar el acceso a Probio. Por favor, intente nuevamente o contacte a soporte.",
  error_probio_service: "El servicio Probio no está activo para su farmacia.",
  error_session: "Error de sesión. Por favor, vuelva a iniciar sesión.",
  error_server:
    "Error de conexión con el servidor. Por favor, intente nuevamente.",

  // Probiomentor — Servicio de abordaje (Etapa 08)
  probio_step_staff_title: "¿Quién realiza el abordaje?",
  probio_step_indication_title: "¿Cuál es la indicación del paciente?",
  probio_step_probiotics_title: "Probióticos con evidencia científica",
  probio_see_stats: "Ver mis estadísticas",
  probio_search_placeholder: "Buscar indicación...",
  probio_in_stock: "Preferente",
  probio_evidence: "Evidencia",
  probio_dosage: "Pauta",
  probio_accepted: "✓ Abordaje Aceptado",
  probio_rejected: "✗ Abordaje No Aceptado",
  probio_congrats_accepted: "¡Excelente abordaje! El paciente lo ha aceptado.",
  probio_congrats_rejected:
    "Abordaje registrado. El paciente no lo ha aceptado en esta ocasión.",
  probio_new_advice: "Nuevo abordaje",
  probio_filter_all: "Todas las categorías",
  probio_select_indication: "Selecciona una indicación...",
  probio_search_btn: "Buscar Probióticos con Evidencia Científica",

  // Probiomentor — Consultas (Etapa 09)
  probio_reports_tab: "Servicios Probiomentor",
  probio_team_tab: "Informe Probiomentor",
  probio_team_subtab_services: "Servicios",
  probio_team_subtab_consultas: "Consultas",
  probio_team_services_title: "Servicios Probiomentor - Equipo",
  probio_team_services_help:
    "Desglose por miembro del equipo: abordajes, aceptación, tiempo medio y ventas.",
  probio_team_col_total: "Total abordajes",
  probio_team_col_accepted: "Aceptados",
  probio_team_col_rejected: "No aceptados",
  probio_team_col_rate: "% Aceptación",
  probio_team_col_time: "Tiempo medio (min)",
  probio_team_col_sales: "Ventas (€)",
  probio_team_col_avg_sale: "Media ventas (€)",
  // Datos generales (comparativa con la media y el mejor de Farmaval)
  probio_services_stats_title: "Datos generales",
  probio_services_stats_help:
    "Compara los indicadores clave de tu farmacia con la media y el mejor valor de Farmaval.",
  probio_services_stats_col_indicator: "Indicador",
  probio_services_stats_col_pharmacy: "Tu farmacia",
  probio_services_stats_col_average: "Promedio farmacias",
  probio_services_stats_col_best: "Mejor farmacia",
  probio_dg_services: "Servicios prestados",
  probio_dg_services_per_day: "Media de servicios por día",
  probio_dg_services_per_person: "Media de servicios por persona del equipo",
  probio_dg_avg_time: "Tiempo medio (min)",
  probio_dg_total_sales: "Total ventas (€)",
  probio_dg_avg_sale: "Media de ventas por servicio (€)",
  probio_dg_with_sales: "Abordajes aceptados (%)",
  // Indicaciones más frecuentes
  probio_indications_title: "Indicaciones más frecuentes",
  probio_indications_help:
    "Indicaciones más consultadas en tu farmacia, con su peso frente a la media de Farmaval.",
  probio_indications_col_name: "Indicación",
  probio_indications_col_pharmacy: "Tu farmacia (%)",
  probio_indications_col_average: "Promedio farmacias (%)",
  probio_indications_empty: "Sin datos en el periodo seleccionado.",
  probio_indications_others: "Otros",
  // Probióticos más dispensados
  probio_top_title: "Probióticos más dispensados",
  probio_top_help: "Los tres probióticos más recomendados en tu farmacia.",
  probio_top_col_rank: "Posición",
  probio_top_col_pharmacy: "Tu farmacia",
  // Probióticos vendidos
  probio_products_title: "Probióticos vendidos",
  probio_products_help: "Probióticos vendidos por tu farmacia.",
  probio_products_col_product: "Producto",
  probio_products_col_quantity: "Cantidad",
  probio_products_col_total: "Total (€)",
  probio_products_total_row: "Total",
  probio_products_empty: "Sin ventas registradas en el periodo seleccionado.",
  // Baja lógica de servicios del historial Probiomentor
  probio_history_col_actions: "Acciones",
  probio_history_deleted_badge: "Dado de baja",
  probio_history_delete_popup_title: "Dar de baja servicio Probiomentor",
  probio_history_delete_popup_text:
    "El servicio dejará de contar en los listados y las estadísticas. Esta acción no borra el registro, solo lo marca como dado de baja.",
  probio_history_delete_reason_label: "Motivo de la baja",
  probio_history_deleted_ok: "Servicio dado de baja correctamente.",
};
